"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameModeEnum = void 0;
var GameModeEnum;
(function (GameModeEnum) {
  /** Предпросмотр урока во время редактирования */
  GameModeEnum["preview"] = "preview";
  /** Самостоятельное прохождение */
  GameModeEnum["single"] = "single";
  /** Прохождение урока в режиме теста */
  GameModeEnum["test"] = "test";
  /** Совместное прохождение */
  GameModeEnum["multiplayer"] = "multiplayer";
  /** Прохождение уроков типа "Словарный запас" в режиме меморайзера */
  GameModeEnum["memorizer"] = "memorizer";
  /** Прохождение уроков типа "Словарный запас" в режиме одного сценария */
  GameModeEnum["scenario"] = "scenario";
})(GameModeEnum = exports.GameModeEnum || (exports.GameModeEnum = {}));
